import { RefObject, useRef } from 'react';

export const useScrollIntoView = <T extends HTMLElement>(
  delay = 0,
  callback?: () => void
): [() => void, RefObject<T>] => {
  const targetRef = useRef<T>(null);

  const executeScroll = () => {
    if (callback) {
      callback();
    }

    setTimeout(() => {
      if (targetRef && targetRef.current) {
        targetRef.current.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      }
    }, delay);
  };

  return [executeScroll, targetRef];
};
